type HomeInteraction = {
  id: string;
  user_interactions: {
    interactions: Interaction[];
  }[];
};

type Interaction = {
  rating?: ContentData;
  poll?: ContentData;
};

type ContentData = {
  documentId: string;
  hideOnResultsPage: boolean;
};

function usePollResults(eventData: any) {
  let ratings: string[] = [];
  let polls: string[] = [];

  const handleInteraction = (interaction: Interaction) => {
    if (interaction?.poll) {
      if (!interaction.poll || interaction.poll?.hideOnResultsPage) {
        return;
      }

      polls.push(interaction.poll?.documentId);
    }
    if (interaction?.rating) {
      if (!interaction.rating || interaction.rating?.hideOnResultsPage) {
        return;
      }
      ratings.push(interaction.rating.documentId);
    }
  };

  const homeInteractions =
    eventData?.homePage.filter(
      (el: any) => el.__typename === 'ComponentIntersIntersGrpHome'
    ) || [];

  const experiences = eventData?.homePage.filter(
    (el: any) => el.__typename === 'ComponentExperienceExperienceGroup'
  );

  homeInteractions.forEach((element: HomeInteraction) => {
    element.user_interactions?.forEach((interactionGroup) => {
      interactionGroup?.interactions.forEach((interaction) => {
        handleInteraction(interaction);
      });
    });
  });

  experiences.forEach((element: any) => {
    element?.experience?.experience_items?.forEach((item: any) => {
      item.interactions?.userInteraction?.interactions?.forEach(
        (interaction: any) => {
          handleInteraction(interaction);
        }
      );
    });
  });

  const finalPolls = [...new Set(polls)];
  const finalRatings = [...new Set(ratings)];

  return { polls: finalPolls, ratings: finalRatings };
}

export default usePollResults;
